import "../assets/styles/main.scss";

interface Props {
  isLoading: boolean;
}

const Loading = ({ isLoading }: Props) => {
  if (!isLoading) return null;

  return (
    <div className="loading-overlay">
      <div className="spinner"></div>
    </div>
  );
};

export default Loading;